export const getCountryWithCode = (code: string) => {
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

  return code && regionNames.of(code);
};
